import {
	reCountryConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	list       : null,
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reCountryConstants.GetPaged.REQUEST:
		case reCountryConstants.GetPagedAudit.REQUEST:
		case reCountryConstants.GetPagedAll.REQUEST:
		case reCountryConstants.GetList.REQUEST:
		case reCountryConstants.Create.REQUEST:
		case reCountryConstants.Delete.REQUEST:
		case reCountryConstants.Restore.REQUEST:
		case reCountryConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reCountryConstants.GetPaged.FAILURE:
		case reCountryConstants.GetPagedAudit.FAILURE:
		case reCountryConstants.GetPagedAll.FAILURE:
		case reCountryConstants.GetList.FAILURE:
		case reCountryConstants.Create.FAILURE:
		case reCountryConstants.Delete.FAILURE:
		case reCountryConstants.Restore.FAILURE:
		case reCountryConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reCountryConstants.GetPaged.SUCCESS:
		case reCountryConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reCountryConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reCountryConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reCountryConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reCountryConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reCountryConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reCountryConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reCountryConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				list       : null,
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}